import { createActionGroup, props } from "@ngrx/store";
import {MappedExportRequest} from '../../../models/export-requests/export-request.models';
import {GetChildOfRequest$Params} from '../../../../swagger-gen/web-secured/fn/reporting/get-child-of-request';
import { PagingAttributes } from "../../../../swagger-gen/gnvert-secured/models";


export const ExportRequestsChildrenActions = createActionGroup({
  source: "[Export Requests Children]",
  events: {
    Search: props<{filter: GetChildOfRequest$Params}>(),
    "Fetch Success": props<{ response: {paging: PagingAttributes, list: Array<MappedExportRequest>, parentId: string} }>(),
    "Fetch Failure": props<{ message: string, parentId: string }>(),
  },
});

